import './../Login.scss';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import { UserAccount } from 'modules/account/AccountService2';
import { AppCuesService } from 'modules/shared/AppCuesService';
class LoginController {
    static $inject = ['$state', '$timeout', 'BlipService', 'AuthenticationService', 'AccountService2', '$stateParams', '$location', 'DiscourseValidationService', 'SegmentService', '$http'];
    constructor($state, $timeout, BlipService, AuthenticationService, AccountService2, $stateParams, $location, DiscourseValidationService, SegmentService, $http) {
        'ngInject';
        this.$state = $state;
        this.$timeout = $timeout;
        this.BlipService = BlipService;
        this.AuthenticationService = AuthenticationService;
        this.AccountService2 = AccountService2;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.DiscourseValidationService = DiscourseValidationService;
        this.SegmentService = SegmentService;
        this.$http = $http;
        this.redirectState = this.$stateParams.currentState;
        this.redirectStateParams = this.$stateParams.currentParams;
        this.payload = this.$stateParams.sso;
        this.sig = this.$stateParams.sig;
        this.loading = false;
        this.email = '';
        this.password = '';
        this.redirectUrl = this.$stateParams.redirectUrl;
        $timeout(() => {
            this.email = (document.getElementById('email')).value;
            this.password = (document.getElementById('password')).value;
            if (this.email) {
                this.loginForm.password.$setValidity('required', true);
            }
        }, 5000);
    }
    async login() {
        if (!this.loginForm.$valid) {
            return;
        }
        this.loading = true;
        if (!this.redirectState ||
            !this.redirectState.name ||
            !this.redirectUrl) {
            this.redirectState = { name: 'auth.application.list' };
        }
        try {
            await this.AuthenticationService.login(this.email, this.password);
            this.$timeout(() => {
                this.SegmentService.createTrack('login', {});
            }, 650);
            if (this.redirectUrl && typeof this.redirectUrl === 'string') {
                window.location.href = this.AuthenticationService.getAuthRedirectUrl(this.redirectUrl);
            }
            else {
                await this.AccountService2.connect();
                if (this.$stateParams.provider) {
                    const ssoResponse = await this.BlipService.sendCommand({
                        id: uuid(),
                        to: 'postmaster@portal.blip.ai',
                        method: 'get',
                        uri: `/sso/${this.$stateParams.provider}`,
                    });
                    window.location.href = ssoResponse.redirectUri;
                    return;
                }
                await this.DiscourseValidationService.redirectToDiscourse(this.payload, this.sig);
                if (this.$state.params && this.$state.params.redirectUrl) {
                    const redirectState = this.$state.params.redirectUrl;
                    this.$state.go(redirectState.toState.name, {
                        ...redirectState.toParams,
                    });
                }
                else {
                    this.$state.go(this.redirectState.name, this.redirectStateParams, { reload: true });
                    const { userPlan, userSubscription } = await this.retrieveUserBillingInfo();
                    const userAccount = await this.AuthenticationService.getAccount()
                        ? await this.AuthenticationService.getAccount()
                        : new UserAccount();
                    const { fullName, culture, email, created, userProfile } = userAccount
                        ? userAccount
                        : { fullName: undefined,
                            culture: undefined,
                            email: undefined,
                            created: undefined,
                            userProfile: undefined,
                        };
                    this.SegmentService.setAccount({}, userPlan, userSubscription);
                    AppCuesService.instance.identify(email, {
                        email,
                        name: fullName,
                        culture,
                        createdAt: moment.utc(created).format('YYYY-MM-DD'),
                        userProfile,
                        planOwnerIdentity: userPlan.ownerIdentity,
                        planId: userPlan.id,
                        planName: userPlan.name,
                        planExtras: userPlan.extras,
                        subscriptionOwnerIdentity: userSubscription.ownerIdentity,
                        subscriptionId: userSubscription.id,
                        subscriptionPlanId: userSubscription.planId,
                        subscriptionSubscriber: userSubscription.subscriber,
                        subscriptionStartDate: userSubscription.startDate,
                        subscriptionLastChangeDate: userSubscription.lastChangeDate,
                        subscriptionEndDate: userSubscription.endDate,
                        subscriptionIsActive: userSubscription.isActive,
                        subscriptionIsPending: userSubscription.isPending,
                    });
                }
            }
        }
        catch (e) {
            console.error(e);
            this.loginError = e;
        }
        finally {
            this.loading = false;
        }
    }
    /**
     * Retrieves the user billing information in BlipService.
     * @async @private
     * @function retrieveUserBillingInfo
     */
    async retrieveUserBillingInfo(userPlan, userSubscription) {
        await this.AccountService2.connect();
        userSubscription = userSubscription
            ? userSubscription
            : await this.AccountService2.getActiveSubscription();
        userPlan = userPlan
            ? userPlan
            : await this.AccountService2.getAccountPlan();
        return { userPlan, userSubscription };
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
LoginController.$inject = ['$state', '$timeout', 'BlipService', 'AuthenticationService', 'AccountService2', '$stateParams', '$location', 'DiscourseValidationService', 'SegmentService', '$http'];
export default LoginController;
